import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Store, Image as ImageIcon, LogOut, Monitor, ShoppingCart, MessageSquare, Landmark } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import MobileAgents from "../components/mobile/MobileAgents";
import MobileClients from "../components/mobile/MobileClients";
import MobileUsers from "../components/mobile/MobileUsers";
import ContentPanel from "../components/dashboard/ContentPanel";
import MobileOrders from "../components/mobile/MobileOrders";
import PushToggle from "../components/mobile/PushToggle";
import Logo from "../components/Logo";
import BackButton from "../components/BackButton";
import MobileContacts from "../components/mobile/MobileContacts";

const TABS = [
  { id: "ordini", label: "Ordini", icon: ShoppingCart },
  { id: "agenti", label: "Agenti", icon: Users },
  { id: "clienti", label: "Clienti", icon: Store },
  { id: "richieste", label: "Richieste", icon: MessageSquare },
  { id: "sito", label: "Sito", icon: ImageIcon },
];

export default function MobileAdmin() {
  const [tab, setTab] = useState(new URLSearchParams(window.location.search).get("tab") || "ordini");
  const [bankN, setBankN] = useState(0);
  const [ordersKey, setOrdersKey] = useState(0);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/"); };
  useEffect(() => {
    api.get("/shop/orders/awaiting-count").then(({ data }) => setBankN(data.awaiting_transfer || 0)).catch(() => {});
  }, [tab]);

  return (
    <div className="min-h-screen paper-grain flex flex-col" data-testid="mobile-admin">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-stone-200" style={{ paddingTop: "env(safe-area-inset-top)" }}>
        <div className="px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <BackButton className="px-2" />
            <Logo size={32} />
            <div>
              <div className="font-serif text-base font-bold text-[#0B2A45] leading-tight">GS Admin</div>
              <div className="text-[11px] text-stone-500 leading-tight" data-testid="mobile-user-name">{user?.name}</div>
            </div>
          </div>
          <div className="flex items-center gap-1">
            {bankN > 0 && (
              <button onClick={() => { setOrdersKey((k) => k + 1); setTab("ordini"); }} className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-full bg-[#FEF9C3] text-[#854D0E] border border-[#FDE68A]" data-testid="mobile-bank-awaiting-badge">
                <Landmark className="w-3 h-3" />{bankN}
              </button>
            )}
            <PushToggle />
            <a href="/admin" className="p-2 text-stone-500" data-testid="mobile-open-desktop" title="Versione completa"><Monitor className="w-5 h-5" /></a>
            <button onClick={doLogout} className="p-2 text-stone-600" data-testid="mobile-logout-btn"><LogOut className="w-5 h-5" /></button>
          </div>
        </div>
      </header>

      <main className="flex-1 px-4 py-4 pb-28">
        {tab === "ordini" && <MobileOrders key={ordersKey} initialSource={ordersKey > 0 ? "negozio" : undefined} />}
        {tab === "agenti" && <MobileAgents />}
        {tab === "clienti" && (<><MobileClients /><MobileUsers /></>)}
        {tab === "richieste" && <MobileContacts />}
        {tab === "sito" && <ContentPanel />}
      </main>

      <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-stone-200" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="mobile-tabbar">
        <div className="grid grid-cols-5 h-16">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button key={id} onClick={() => setTab(id)} data-testid={`mobile-tab-${id}`}
              className={`flex flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${tab === id ? "text-[#0F4C81]" : "text-stone-400"}`}>
              <span className="relative"><Icon className={`w-5 h-5 ${tab === id ? "stroke-[2.5]" : ""}`} />
                {id === "ordini" && bankN > 0 && <span className="absolute -top-1.5 -right-2 bg-[#C2593F] text-white text-[9px] rounded-full min-w-[15px] h-[15px] px-1 flex items-center justify-center" data-testid="mobile-tab-ordini-badge">{bankN}</span>}
              </span>{label}
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
}
